package devxertech.com.pages.commons

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import kotlinx.browser.window
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.px

@Composable
fun ManagementSoftwareNew(
    image: String,
    sideImage: String,
    title: String,
    description: String,
    imageWidth: CSSLengthOrPercentageNumericValue = 100.px,
    imageHeight: CSSLengthOrPercentageNumericValue = 100.px,
    paddingChanges: Boolean = false, titleChanges: Boolean = false,marginChanges: Boolean = false
) {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()

    val cardHeight = if (breakpoint > Breakpoint.MD) 503.px else 420.px
    val titleHeight = 60.px
    val descriptionHeight = if (window.screen.width < 768) 190.px else 150.px


    Box(
        modifier = Modifier
            .width(
                when {
                    window.screen.width > 1610 -> 400.px
                    window.screen.width in 1441..1600 -> 400.px
                    window.screen.width == 1440 -> 350.px
                    breakpoint == Breakpoint.MD -> 340.px
                    window.screen.width < 375 -> 290.px
                    else -> 320.px
                }
            )
            .height(cardHeight)
            .margin(topBottom = 20.px)
            .backgroundColor(Colors.White)
            .boxShadow(blurRadius = 20.px, color = Colors.LightGray)
    ) {
        Row(
            modifier = Modifier.fillMaxSize()
        ) {
            // 👉 Side arrow image *inside* card
            Image(
                src = sideImage,
                modifier = Modifier
                    .width( if (window.screen.width < 475) 50.px else 87.px)
                    .fillMaxHeight()
                    .align(Alignment.CenterVertically)
            )

            // 👉 Card content
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(top = if (breakpoint <= Breakpoint.MD) 77.px else 120.px,
                        right = if (breakpoint > Breakpoint.MD) 60.px else if (window.screen.width < 375) 30.px else 45.px),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(16.px)
            ) {
                // Icon
                Image(
                    src = image,
                    modifier = Modifier
                        .width(imageWidth)
                        .height(imageHeight)
                )

                // Title
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .display(DisplayStyle.Contents)
                        .height(titleHeight),
                    contentAlignment = Alignment.TopCenter
                ) {
                    SpanText(
                        text = title.uppercase(),
                        modifier = Modifier
                            .fontSize(if (window.screen.width < 375) 16.px else 18.px)
                            .fontFamily(Constants.FONT_FAMILY)
                            .color(sitePalette.commonSecondaryButtonColor.rgb)
                            .fontWeight(FontWeight.Bold)
                            .lineHeight(23.px)
                            .textAlign(TextAlign.Center)
                            .letterSpacing(0.1.px)
                            .padding(left = if (titleChanges && breakpoint > Breakpoint.MD) 13.px else
                                if (marginChanges && breakpoint < Breakpoint.MD) 12.px else 5.px,
                                top = if (titleChanges && breakpoint > Breakpoint.MD) 5.px else
                                    if (marginChanges && breakpoint < Breakpoint.MD) 6.px else 0.px)
                    )
                }

                // Description
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(descriptionHeight),
                    contentAlignment = Alignment.TopCenter
                ) {
                    SpanText(
                        text = description,
                        modifier = Modifier
                            .fontSize(14.px)
                            .fontFamily(Constants.FONT_FAMILY)
                            .textAlign(TextAlign.Center)
                            .whiteSpace(WhiteSpace.PreWrap)
                            .color(sitePalette.commonSecondaryButtonColor.rgb)
                            .fontWeight(FontWeight.Normal)
                            .padding(if (paddingChanges && breakpoint > Breakpoint.LG) 17.px else 0.px)
                    )
                }
            }
        }
    }
}

